export const hasColor = (color: string | undefined) =>
  color && color !== 'transparent';

export const space = (_space: number | undefined) => _space || 12;

export const padding = (_space: number | undefined) => space(_space) + 4;
